import React, { ReactElement } from 'react'
import VisibilitySensor from 'react-visibility-sensor'
import { ISearch } from '../../types/search'
import { Space } from '../../layouts'
import Button from '../StyledButton'
import { StyledNoResults, StyledControlledInfiniteScroll } from './styled'

export interface IControlledInfiniteScroll {
  component: (props: any) => ReactElement
  takeNextChunk: () => void
  search: ISearch
}

export const ControlledInfiniteScroll = ({
  component: List,
  takeNextChunk,
  search,
}: IControlledInfiniteScroll) => (
  <StyledControlledInfiniteScroll>
    <List items={search.items} />
    <Space mt={12} mb={12}>
      {search.items.length === search.totalCount ? (
        <StyledNoResults align="center">
          No more graphics in this group
        </StyledNoResults>
      ) : (
        <StyledNoResults align="center">
          <VisibilitySensor
            onChange={(isVisible) => {
              if (isVisible) {
                takeNextChunk()
              }
            }}
          >
            <Button onClick={takeNextChunk}>Show more</Button>
          </VisibilitySensor>
        </StyledNoResults>
      )}
    </Space>
  </StyledControlledInfiniteScroll>
)
